export const SELECT_CATEGORY   = 'SELECT_CATEGORY'
export const SELECT_COLLECTION = 'SELECT_COLLECTION'